import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/sys/table"

const sysTable = {
  tableList(page, limit) {
    return axios.post(pre + `/tableList`, qs.stringify({page: page, limit: limit}));
  },
  getTableColumList(tableName) {
    return axios.post(pre + `/tableInfoColumns`, qs.stringify({tableName: tableName}));
  },
  goGenerator(tableName, columnList, moduleName,moduleTwoName) {
    return axios.post(pre + `/goGenerator`, qs.stringify({
      tableName: tableName,
      columnList: columnList,
      moduleName: moduleName,
      moduleTwoName: moduleTwoName
    }));
  },
}
export default sysTable;



// WEBPACK FOOTER //
// ./src/api/sys/table.js